export const GhostIdentifiedResult = () => {
  return (
    <div className="box has-text-centered">
      <span className="icon has-text-success">
        <i className="fa fa-2x fa-check" />
      </span>
      <p className="my-3 is-uppercase has-letter-spacing">Ghost identified!</p>
      <p>Don't forget to update the in-game journal.</p>
    </div>
  )
}

export default GhostIdentifiedResult
